var map = {
	"./3rdParty.svg": 263,
	"./Accident.svg": 264,
	"./Bicycle.svg": 265,
	"./Boat.svg": 266,
	"./Buildings.svg": 267,
	"./Car.svg": 268,
	"./Child.svg": 269,
	"./Content.svg": 270,
	"./Contents.svg": 271,
	"./CriticalIllness.svg": 272,
	"./Dental.svg": 273,
	"./Drone.svg": 274,
	"./ExtendedWarranty.svg": 275,
	"./Family.svg": 276,
	"./Gadget.svg": 277,
	"./Health.svg": 278,
	"./Hospitalização.svg": 279,
	"./Housekeeper.svg": 280,
	"./Hunter.svg": 281,
	"./Income.svg": 282,
	"./Investment.svg": 283,
	"./Life.svg": 284,
	"./LocalLodging.svg": 285,
	"./Mobile.svg": 286,
	"./Mortgage.svg": 287,
	"./Motorbike.svg": 288,
	"./Other.svg": 289,
	"./PPR.svg": 290,
	"./Pet.svg": 291,
	"./Scooter.svg": 292,
	"./Sports.svg": 293,
	"./Thirdpartypet.svg": 294,
	"./Travel.svg": 295,
	"./Warranty.svg": 296,
	"./White_goods.svg": 297,
	"./WorkAccident.svg": 298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;